import {combine, createEffect} from 'effector';

import {loadGridCsv} from 'api';
import {fetchGtinsGrid} from 'api/registries';
import {createGridListModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {SimplePaginationContent} from 'types/api';
import {GtinsGridRawRow} from 'types/gtins';

const domain = rootDomain.createDomain('GtinsGridListDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchGtinsGrid,
});

export const fetchCsv = createEffect({
    name: 'fetchRegistriesCsv',
    handler: loadGridCsv,
});

export const {
    Gate,
    pageNumber$,
    pageNumberChanged,
    pageIncremented,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    filtersSubmit,
    filtersReset,
    sortings$,
    sortingsChanged,
    sortingsReset,
    listStateChanged,
    showConfigBlock$,
    showConfigBlockChanged,
    stateReset,
} = createGridListModel({domain});

export const data$ = domain.createStore<SimplePaginationContent<GtinsGridRawRow> | null>(null);

export const listState$ = combine({
    data: data$,
    filters: filters$,
    sortings: sortings$,
    pageIncremented,
    isLoading: fetchDataFx.pending,
    exportPending: fetchCsv.pending,
    showConfigBlock: showConfigBlock$,
});
